import { createContext, useContext, type ReactNode } from "react";
import type { HeroApi } from "./types";

const ApiContext = createContext<HeroApi | null>(null);

export function ApiProvider({ api, children }: { api: HeroApi; children: ReactNode }) {
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
}

export function useApi(): HeroApi {
  const api = useContext(ApiContext);
  if (!api) throw new Error("useApi outside of ApiProvider");
  return api;
}
